const LANG_KEY = "vmtipset_lang";
const THEME_KEY = "betting-theme";

/** Read pre-login browser preferences (localStorage only). */
export function readClientPreferences() {
  let preferred_lang = "sv";
  let preferred_theme = "light";
  try {
    preferred_lang = localStorage.getItem(LANG_KEY) === "en" ? "en" : "sv";
    const theme = localStorage.getItem(THEME_KEY);
    preferred_theme = theme === "dark" ? "dark" : "light";
  } catch {
    /* ignore */
  }
  return { preferred_lang, preferred_theme };
}
